import React from 'react'
import classNames from 'classnames'
import cls from './rounded-button.module.scss'
import { Link } from 'react-router-dom'

const VARIATIONS = {
  OUTLINE: cls.outline,
  PLAIN: cls.plain,
  ICON: cls.icon,
  DARK: cls.dark,
  LIGHT: cls.light,
}

const RoundedButton = props => {
  const { variant = 'LIGHT', className, loading, children, ...restProps } = props

  let Container = 'button'

  if (restProps.to) {
    Container = Link
  }

  return (
    <Container
      {...restProps}
      className={classNames(cls.button, VARIATIONS[variant], className, {
        [cls.loading]: loading,
      })}
    >
      {children}
    </Container>
  )
}

export default RoundedButton
